module.exports = __webpack_public_path__ + "img/hest6.901c44fb.jpg";